// Cliente HTTP do módulo. O sistema principal injeta a URL e os headers de autenticação.
let config = {
  baseUrl: '/api/v1' /* URL definida por configureFolhaApiEtapa6 (integração FSC) */,
  getHeaders: async () => ({}),
}

export function configureApi({ baseUrl, getHeaders } = {}) {
  config = {
    baseUrl: baseUrl ?? config.baseUrl,
    getHeaders: getHeaders ?? config.getHeaders,
  }
}

async function request(method, path, body) {
  const headers = { 'Content-Type': 'application/json', ...(await config.getHeaders()) }
  const resp = await fetch(`${config.baseUrl}${path}`, {
    method,
    headers,
    body: body === undefined ? undefined : JSON.stringify(body),
  })
  const data = await resp.json().catch(() => null)
  if (!resp.ok) {
    const detail = data?.detail
    const msg = Array.isArray(detail) ? detail.map((d) => d.msg).join('; ') : detail || resp.statusText
    throw new Error(msg)
  }
  return data
}

export const api = {
  obterTributacao: (empresaId) => request('GET', `/empresas/${encodeURIComponent(empresaId)}/tributacao`),
  salvarTributacao: (empresaId, dados) => request('PUT', `/empresas/${encodeURIComponent(empresaId)}/tributacao`, dados),
  obterEncargos: (empresaId, competencia) =>
    request('GET', `/empresas/${encodeURIComponent(empresaId)}/encargos?competencia=${competencia}`),
  listarParametros: () => request('GET', '/parametros-legais'),
  parametrosVigentes: (competencia) => request('GET', `/parametros-legais/vigentes/${competencia}`),
  simularFolha: (entrada) => request('POST', '/folha/simular', entrada),
  enfileirarFolha: (entrada) => request('POST', '/folha/lotes', entrada),
  statusLote: (loteId) => request('GET', `/folha/lotes/${loteId}`),
}
